import { render, staticRenderFns } from "./majorReviewed.vue?vue&type=template&id=9017fc00"
import script from "./majorReviewed.vue?vue&type=script&lang=js"
export * from "./majorReviewed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports